export default __webpack_public_path__ + "static/media/instructor_icon.023fb048.png";